import { render } from "./WorkStationCard.vue?vue&type=template&id=9c49c18a"
import script from "./WorkStationCard.vue?vue&type=script&lang=js"
export * from "./WorkStationCard.vue?vue&type=script&lang=js"

import "./WorkStationCard.vue?vue&type=style&index=0&id=9c49c18a&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__